<script lang="ts">
	import { cn } from "#lib/web-ui/ui/utils.js";
	import { getGlossaryContext } from "./glossary-context.svelte";

	interface Props {
		label?: string;
		class?: string;
	}

	let { label, class: className }: Props = $props();

	const glossary = getGlossaryContext();
</script>

<button
	type="button"
	class={cn(
		"text-primary focus-visible:ring-ring cursor-pointer font-semibold underline underline-offset-4 focus-visible:ring-2 focus-visible:outline-none",
		className
	)}
	onclick={() => (glossary.open = true)}
>
	{label ?? glossary.copy.openLabel}
</button>
